var heading_default = {
  "fontElementMap": "_2qnPz",
  "elementSpacing": "eW6-t",
  "headerOne": "VFzrR eW6-t",
  "headerTwo": "PQwMB eW6-t",
  "headerThree": "PVT0q eW6-t",
  "headerFour": "_5Htxg eW6-t",
  "headerFive": "-sxiq eW6-t",
  "headerSix": "ZtW7T eW6-t",
  "child": "IwXx7"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
